import React, { useContext } from 'react';
import classNames from 'classnames';

import { postToChownowApi } from 'helpers/api';
import {
  HELP_URL,
  FOR_RESTAURANTS_DESKTOP_URL,
  RESTAURANT_LOGIN,
} from '@chownow/cn-web-utils/paths';

import { CustomerContext } from 'context/customer';
import { ModalContext } from 'context/modal';
import { clearSavedAddressId } from 'helpers/localStorage';
import { logoutMparticleUser } from 'helpers/mParticle';

import ModalComponents, { AuthModalStates } from 'types/modals';

import styles from './DropdownMenu.module.scss';

interface DropdownMenuProps {
  isAuthed: boolean;
  toggleDropdown: () => void;
}

function DropdownMenu({ isAuthed, toggleDropdown }: DropdownMenuProps) {
  const { showModal } = useContext(ModalContext);
  const { setUser } = useContext(CustomerContext);

  const toggleAuthModal = (authModalState: AuthModalStates): void => {
    showModal({
      modalType: ModalComponents.AUTH,
      modalProps: {
        activeAuthModal: authModalState,
      },
    });
    toggleDropdown();
  };

  const handleClickLogout = async (): Promise<void> => {
    const { data } = await postToChownowApi('customer/logout', {});
    if (data) {
      setUser(null);
      logoutMparticleUser();
      clearSavedAddressId();
    }
    toggleDropdown();
  };

  return (
    <ul className={styles.dropdownMenu}>
      {isAuthed ? (
        <>
          <li className={styles.menuOption}>
            <a href="/order/account">Account Settings</a>
          </li>
          <li className={styles.menuOption}>
            <a href="/order/history">Order History</a>
          </li>
          <li className={styles.menuOption}>
            <a href={HELP_URL} target="_blank" rel="noreferrer">
              Help
            </a>
          </li>
          <li className={styles.menuOption}>
            <button onClick={handleClickLogout} type="button">
              Log Out
            </button>
          </li>
        </>
      ) : (
        <li className={styles.menuOption}>
          <button onClick={() => toggleAuthModal(AuthModalStates.loginSignUp)} type="button">
            Log In or Sign Up
          </button>
        </li>
      )}
      <li className={classNames(styles.menuOption, styles.divider)}>
        <a href={FOR_RESTAURANTS_DESKTOP_URL} target="_blank" rel="noreferrer">
          For Restaurants
        </a>
      </li>
      {!isAuthed && (
        <li className={styles.menuOption}>
          <a href={RESTAURANT_LOGIN} target="_blank" rel="noreferrer">
            Restaurant Log In
          </a>
        </li>
      )}
    </ul>
  );
}

export default DropdownMenu;
